"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _MarkerRatesTable = _interopRequireDefault(require("web/shared/telemetry/charts/MarkerRatesTable"));
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* How often each marker fired, as a card of its own.
*
* A phase boundary sits at 100% and is not the interesting row; a conditional
* event's rate is the thing worth knowing.
*/
function MarkerRates(_ref) {
  let records = _ref.records,
    markerMeanings = _ref.markerMeanings;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.wideCard)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.subHeading)), {}, {
      children: "Marker Rates"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panelDescription)), {}, {
      children: "How often each marker fired. A phase boundary sits at 100%; a conditional event\u2019s rate is the thing worth knowing."
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerRatesTable.default, {
      records: records,
      markerMeanings: markerMeanings
    })]
  }));
}
var _default = exports.default = MarkerRates;